import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigPresorteoListComponent } from './config-presorteo-list.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';



@NgModule({
  declarations: [
    ConfigPresorteoListComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    ButtonModule
  ], exports: [
    ConfigPresorteoListComponent
  ]
})
export class ConfigPresorteoListModule { }
